
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.29 20.01h37.13v1.39H11.29v-1.39zM47.14 16.73h1.27V18h-1.27v-1.27zM46.11 16.73h-1.27V18h1.27v-1.27zM42.53 16.73h1.27V18h-1.27v-1.27z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51.75 42.97V16.23A2.23 2.23 0 0049.53 14H10.27a2.23 2.23 0 00-2.22 2.23v6.688a.994.994 0 00-.05.312v19.74a2.23 2.23 0 002.22 2.23h39.26a2.23 2.23 0 002.27-2.23zm-2-20.74h-39.7v-6a.23.23 0 01.23-.23h39.25a.22.22 0 01.22.23v6zm-39.75 2h39.7v18.74a.23.23 0 01-.22.23H10.22a.229.229 0 01-.22-.23V24.23z"}})])
          )
        }
      }
    